// src/pages/support/components/DeleteTeamModal.jsx
import React from "react";
import Modal from "./Modal";

function DeleteTeamModal({ team, isDeleting, error, onClose, onConfirm }) {
  if (!team) return null;

  return (
    <Modal title={`حذف تیم: ${team?.name || ""}`} onClose={onClose}>
      <div className="space-y-4">
        {error && <div className="text-red-400 text-sm">{error}</div>}

        <div
          className="rounded-xl border p-4"
          style={{ borderColor: "rgba(55,65,81,0.5)", backgroundColor: "rgba(31,41,55,0.55)" }}
        >
          <p className="text-gray-200">
            آیا از حذف تیم <span className="text-white font-semibold">{team?.name}</span> مطمئن هستید؟
          </p>
          <p className="text-gray-400 text-sm mt-1">
            این عملیات قابل بازگشت نیست. {Array.isArray(team?.members) ? `تعداد اعضا: ${team.members.length}` : ""}
          </p>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-xl text-gray-200 border"
            style={{ borderColor: "rgba(55,65,81,0.6)", backgroundColor: "rgba(17,24,39,0.6)" }}
          >
            انصراف
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className={`px-4 py-2 rounded-xl text-white ${isDeleting ? "opacity-70" : ""}`}
            style={{ backgroundColor: "#ef4444" }}
          >
            {isDeleting ? "در حال حذف..." : "تأیید حذف"}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default DeleteTeamModal;